<template>
  <div class="box">
    <img class="activity-bg" src="../../../../static/model-bg23.jpg" alt="" />
    <div class="activity-time">
        <p v-if="status==2">活动倒计时：<span>{{ H }}</span> 时 <span>{{ M }}</span> 分 <span>{{ S }} </span> 秒</p>
        <p v-if="status==1">活动尚未开始</p>
        <p v-if="status==0">活动已下线</p>
        <p v-if="status==3">活动已结束</p>
      </div>
    <div class="activity-content">
      
      <div >充<span>{{materialParamsDTO.materialParamsDetailDTOList[0].rechargeMoney}}</span>多送<span>{{materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMoney}}</span></div>
      <p>共得{{materialParamsDTO.materialParamsDetailDTOList[0].totalbookCoin}}书币</p>
       <button v-if="status==2" @click="goTopay">立即充值</button>
      <button v-else class="default-btn">立即充值</button>
    </div>
    <div class="activity-tip">
      <p>活动规则</p>
      <p>1、活动时间：即日起至<span v-if="endTime">{{endTime}}</span></p>
      <p>2、本次活动
        <span v-if="purchaseLimitDTO.purchaseLimitType==2">参与次数不限</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==1">每天仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==0">每人仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
      </p>
      <p>3、此充值为书币充值，一经充值不支持退款</p>
    </div>
  </div>
</template>
<script>
export default {
   props:['status','materialParamsDTO','endTime','purchaseLimitDTO','H','M','S'],
  data() {
    return {
    };
  },
  watch:{
    materialParamsDTO:{
        handler: function (val) {
         console.log(val)
        },
        deep: true
    },
    purchaseLimitDTO:{
       handler: function (val) {
         console.log(val)
        },
        deep: true
    },
  },
  methods:{
    goTopay(){
      this.$emit('payActivity',this.materialParamsDTO.materialParamsDetailDTOList[0])
    }
  }
};
</script>
<style scoped>
.box {
  position: relative;
}
.activity-bg {
  width: 100%;
  display: block;
}

.activity-time{
  font-size: 15px;
color: #333333;
text-align: center;
position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(150px + env(safe-area-inset-top));
  width: 231px;
  height: 34px;
  border: 2px solid #1E7627;
border-radius: 17px;
line-height: 34px;
} 
.activity-time span{
  color: #e31a0b;
}
.activity-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(193px + env(safe-area-inset-top));
  width: 296px;
height: 243px;
background-image: url('../../../../static/model-content23.png');
background-size: contain;
padding:50px 0px;
box-sizing: border-box;
}
.activity-content > div {
  font-size: 28px;
  color: #333333;
  text-align: center;
  font-weight: bold;
}
.activity-content > div > span {
  color: #e31a0b;
  font-size: 34px;
}
.activity-content > p {
  text-align: center;
  color: #e31a0b;
  font-size: 18px;
  margin-top: 4px;
  margin-bottom: 14px;
  line-height: 28px;
}
.activity-content > button {
  border-radius: 100px;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 47px;
  width: 187px;
height: 47px;
background: #FF5710;
border-radius: 100px;
  border: none;
  margin: 0 auto;
  display: block;
}
.activity-content > button.default-btn{
background: #8D8D8D;
border-radius: 100px;
font-size: 20px;
color: #FFFDFA;
}
.activity-tip {
  position: absolute;
  bottom: 119px;
  left: 50%;
  transform: translateX(-50%);
}
.activity-tip p:nth-of-type(1) {
  text-align: center;
  margin-bottom: 6px;
  font-size: 14px;
}
.activity-tip p {
    white-space: nowrap;
  font-size:12px;
  color:  #333333;
  line-height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modeltwentythree.vue